export default {
	SET_QUEUED_BOOKINGS : (state, data) =>{
        state.queuedBookings = {
            listing: data.listing,
            isLoading: data.isLoading,
            isFetched: data.isFetched,
            total: data.total,
            totalInFilter: data.totalInFilter,
        };
    },
    SET_SELECTED_QUEUED_BOOKING : (state, data) => {
        state.selectedQueuedBooking = {
            ...data
        };
    },
    SET_QUEUED_BOOKING_SUBMITTED: (state, data) => {
        state.queuedBookingSubmitted = {
            ...data
        };
    }
}